<template>
  <div class="withdrawApply">
    <div class="select">
      <el-form ref="form" v-model="request" label-position="right">
        <el-form-item><el-input v-model="request.phone" placeholder="手机号" style="width:150px" clearable></el-input></el-form-item>
        <el-form-item>
          <el-select v-model="request.state" clearable placeholder="提现状态" style="width:200px">
            <el-option v-for="item in this.global.withdraw_state" :key="item.code" :label="item.message" :value="item.code" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="time" type="daterange" popper-class="date-style" :append-to-body="false" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllWithdrawApply">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
          <el-button style="background-color:#FFFF00" icon="el-icon-bottom" @click="exportCurrentPage">导出当前页</el-button>
            <el-button style="background-color:#0040FF;color: #fff" icon="el-icon-bottom" @click="exportAllData">导出所有</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response.data"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                style="margin:auto;width:calc(100% - 30px)" height="667" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="登录账号" align="center" prop="account"></el-table-column>
        <el-table-column label="类型" align="center" prop="type" width="80"></el-table-column>
        <el-table-column label="名称" align="center" prop="name"></el-table-column>
        <el-table-column label="联系电话" align="center" prop="phone"></el-table-column>
        <el-table-column label="申请提现金额" align="center" prop="withdrawMoney" ></el-table-column>
        <el-table-column label="到账金额" align="center" prop="realPayment"></el-table-column>
        <el-table-column label="服务费" align="center" prop="serviceMoney"></el-table-column>
        <el-table-column label="税费" align="center" prop="rateMoney"></el-table-column>
        <el-table-column label="申请时间" align="center" width="200">
          <template slot-scope="scope">{{ scope.row.applyTime | formatDate }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope"><el-tag type="success">{{ scope.row.withdrawState }}</el-tag></template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="warning" plain size="small" @click="withdrawDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
    </div>
    <withdraw-detail v-if="withdrawDetailDialog" ref="withdrawDetail" @succeed="succeed"></withdraw-detail>
  </div>
</template>

<script>
import { getAllPendingApproval, exportPage, exportAll} from "../../../api/withdraw/withdrawapply";
import {GLOBAL_URL} from '../../../config/config.js'
import WithdrawDetail from './withdrawdetail.vue'
import { formatDate } from "../../../utils/date";
export default {
  components: {WithdrawDetail},
  name: "WithdrawApply",
  data() {
    return {
      request: {
        current: '',
        size: '',
        startTime: '',
        endTime: '',
        phone: '',
        state: '',
      },
      global: '',
      dict: '',
      loading: false,
      query: {current: 1,size: 15},
      response: {data: [],total: 0},
      withdrawDetailDialog: false,
      time: ''
    }
  },
  methods: {

    /**
     * 获取提现列表
     */
    getAllWithdrawApply() {
      this.request.startTime = this.time[0];
      this.request.endTime = this.time[1];
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      getAllPendingApproval(this.request).then((result) => {
        this.response.data = result.data.records;
        this.response.total = result.data.total;
      });
    },

    /**
     * 页码改变
     */
    currenChangeHandle(value) {
      this.query.current = value;
      this.getAllWithdrawApply();
    },

    /**
     * 重置
     */
    reset(){
      this.request.phone = "";
      this.request.state = "";
      this.time = "";
      this.query.current = 1;
      this.getAllWithdrawApply();
    },

    /**
     * 导出当前页
     */
    exportCurrentPage() {
      this.$notify({
          message: '正在准备Excel文件，准备完成之后系统将自动下载文件！',
          position: 'bottom-right',
          type: 'success',
          duration: 3000,
          showClose: false
        });
      this.request.startTime = this.time[0];
      this.request.endTime = this.time[1];
      this.request.current = this.query.current;
      this.request.size = this.query.size;
      exportPage(this.request).then((result) => {
        window.open(GLOBAL_URL.excelUpload + result.data);
      });
    },

    /**
     * 导出所有
     */
    exportAllData() {
      this.$notify({
          message: '正在准备Excel文件，准备完成之后系统将自动下载文件！',
          position: 'bottom-right',
          type: 'success',
          duration: 3000,
          showClose: false
        });
      let params = {
        startTime: this.time[0],
        endTime: this.time[1],
        phone: this.phone,
        state: this.request.state,
      };
      exportAll(params).then((result) => {
        window.open(GLOBAL_URL.excelUpload + result.data);
      });
    },

    /**
     * 提现详情
     */
    withdrawDetail(item){
      this.withdrawDetailDialog = true;
      this.$nextTick(()=>{
        this.$refs.withdrawDetail.init(item);
      })
    },

    /**
     * 操作成功重新请求
     */
    succeed(){
      this.getAllWithdrawApply();
    }
  },
  created() {
    this.global = JSON.parse(sessionStorage.getItem("global"));
    this.dict = JSON.parse(sessionStorage.getItem("dict"));
    this.getAllWithdrawApply();
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.withdrawApply {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/withdrawmanagement/withdrawapply.vue